import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { defaultChangeHandler } from '@/components/fileAttachments'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import ItemForm from '@/internal-app/pages/administration/documentation/itemForm'

class EditDocumentationItemDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      ...props.item,
      title: { ...props.item.title },
      file: { ...props.item.file }
    }
  }
  handleTitleChange (language, title) {
    const newState = { ...this.state }
    newState.title[language] = title
    this.setState(newState)
  }
  handleAttachmentChange (language, e) {
    const attachment = (this.state.file || {})[language]
    const existingAttachments = (attachment ? [attachment] : [])
    const attachments = defaultChangeHandler(e, existingAttachments)
    if (attachments !== existingAttachments) {
      const newState = { ...this.state }
      if (!newState.file) { newState.file = {} }
      newState.file[language] = attachments[0]

      this.setState(newState)
    }
  }
  saveChanges = () => {
    this.props.onAction(this.state)
  }
  render () {
    const { localize } = this.props
    return (
      <ValidationBoundary>
        <BasicHeader title='Common.Edit' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            <ItemForm
              localize={localize}
              item={this.state}
              downloadAction={this.props.downloadAction}
              onItemTypeChange={itemType => this.setState({ itemType })}
              onTitleChange={(language, title) => this.handleTitleChange(language, title)}
              onAttachmentChange={(language, e) => this.handleAttachmentChange(language, e)}
            />
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={this.saveChanges} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: EditDocumentationItemDialog,
  modalProps: { size: 'lg' }
}



// WEBPACK FOOTER //
// ./src/dialogs/editDocumentationItem.js